import React, { useEffect } from 'react';
 

function AuthCheck() {
   
  useEffect(() => {
    const token = localStorage.getItem('token'); 

    if (token) {
      // Token exists, redirect to desired route
      
    } else {
      // Token doesn't exist, redirect to login page
      window.location.href = '/';
    }
  }, []);

  return null; // This component doesn't render anything
}

export default AuthCheck;
